"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ExpandableMenuGroup.default;
  }
});
var _ExpandableMenuGroup = _interopRequireDefault(require("./ExpandableMenuGroup"));